import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    auth: {
      token: null, // 用户 jwt token
      uid: null, // 用户 uuid
      expire: null,
      processing: false,
      redirect: null,
      prevFullPath: ''
    },
    productUrl: '', // 暂存准备支付的产品详情页 url
    payFailUrl: '', // 暂存如果用户支付失败或取消后跳转的 url
    paymentResult: {}, // 支付结果 {success: true, message: '支付成功'}
  },
  mutations: {
    authProcessing (state, processing) {
      state.auth.processing = processing
    },
    tokenRefreshed (state, auth) {
      state.auth = auth
    },
    tokenClear (state) {
      state.auth = {}
    },
    setRedirect (state, url) {
      // 认证后需要跳转的页面
      state.auth.redirect = url
    },
    setUid (state, uid) {
      state.auth.uid = uid
    },
    setToken (state, token) {
      state.auth.token = token
      state.auth.expire = new Date().getTime() + 1800 * 1000 * 5
      // state.auth.expire = new Date().getTime() + 10 * 1000 // 10秒
    },
    setProductUrl (state, url) {
      state.productUrl = url
    },
    setPayFailUrl (state, url) {
      state.payFailUrl = url
    },
    setPaymentResult (state, result) {
      state.paymentResult = result
    },
    clearPaymentResult (state) {
      state.paymentResult = {}
    },
    setPrevFullPath (state, fullPath) {
      state.prevFullPath = fullPath
    },
    setFullPathToCategory (state, fullPath) {
      state.fullPathToCategory = fullPath
    },
    setFullPathToTopic (state, fullPath) {
      state.fullPathToTopic = fullPath
    },
    clearPrevFullPath (state) {
      state.prevFullPath = ''
    }
  }
})

export default store
